var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{staticClass:"help-tip-wrap",attrs:{"placement":_vm.placement,"width":"260","title":_vm.title,"trigger":"hover","content":_vm.content}},[_c('i',{staticClass:"el-icon-question help-tip",attrs:{"slot":"reference"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }